import { CSSObject } from "@emotion/react";

import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;
const black = colors.ui.black[500];
const neutral400 = colors.ui.neutral[400];

export const titleInputStyles = (
  align: "left" | "right" | "center" = "left",
): CSSObject => ({
  color: black,
  margin: "8px 0",
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  textAlign: align,
  fontWeight: "bold",
  width: "100%",
  background: "transparent",
  ...typographyStyles.fontFamily.circular,
});
